<template>
  <div class="hidden-danger-quality-chart">
    <custom-panel>
      <template #title>隐患数量类别分布</template>
      <template #default>
        <dv-charts :option="option" v-if="dataLoaded"/>
      </template>
    </custom-panel>
  </div>
</template>

<script>
import CustomPanel from '@/components/custom-panel/index.vue'
import request from '@/util/request.js'

export default {
  components: {
    CustomPanel
  },
  data () {
    return {
      timer: null,
      dataLoaded: false,
      option: {
        title: {
        },
        xAxis: {
          data: [/* '消防安全', '电气安全', '基础管理' */],
          axisLabel: {
            style: {
              fill: '#fff'
            }
          }
        },
        yAxis: {
          data: 'value',
          axisLabel: {
            style: {
              fill: '#fff'
            },
            formatter: function ({ value }) {
              return parseInt(value)
            }
          }
        },
        series: [
          {
            data: [/* 85, 57, 54 */],
            type: 'bar',
            gradient: {
              color: ['#5c52c3', '#6cd1f4']
            },
            barWidth: 30,
            label: {
              show: true,
              style: {
                fill: '#fff'
              }
            }
          }
        ]
      }
    }
  },
  created () {
    this.getYinHuanShuLiangFenBu()
  },
  methods: {
    async getYinHuanShuLiangFenBu () {
      const res = await request.get('/common/yin-huan-shu-liang-fen-bu')
      this.option.xAxis.data = res.data.map((item) => {
        return item.riskTypeName
      })
      this.option.series[0].data = res.data.map((item) => {
        return item.count
      })
      this.dataLoaded = true
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.getYinHuanShuLiangFenBu()
    }, process.env.VUE_APP_DATA_REFRESH_INTERVAL)
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.hidden-danger-quality-chart{
  height: 100%;}
</style>
